import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { setParams } from '../../../../redux/Slices/scrollSlice';

function BreadCrumb({ breadCrumb, setBreadCrumb, setCurrentFolder, tileStyle = false }) {
    const { t } = useTranslation();
    const [folderName, setFolderName] = useState();
    const { params } = useSelector(state => state.scroll)
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            localStorage.setItem("bread_crumb", JSON.stringify([]));
            localStorage.setItem("folder_id", "");
        }
    }, [])

    const goHome = () => {
        if (breadCrumb.length) {
            localStorage.setItem("bread_crumb", JSON.stringify([]));
            localStorage.setItem("folder_id", "");

            dispatch(setParams({ ...params, folder_id: "" }))

            if (window.location.pathname.includes("/media/gallery"))
                navigate(`/media/gallery`)
            else
                dispatch(setParams({ ...params, folder_id: "" }))


            setCurrentFolder({
                id: "",
                name: ""
            });
            setBreadCrumb([]);
        }
    }

    const getFolderContent = (folder_id) => {
        dispatch(setParams({ ...params, folder_id: folder_id }))

        if (window.location.pathname.includes("/media/gallery"))
            navigate(`/media/gallery/${folder_id}`)
        else {
            dispatch(setParams({ ...params, folder_id: folder_id }))
        }

        breadCrumb.map((currentItem, index) => {
            if (currentItem.id == folder_id) {
                localStorage.setItem("bread_crumb", JSON.stringify(breadCrumb.slice(0, index + 1)));
                localStorage.setItem("folder_id", currentItem.id);
                localStorage.setItem("current_folder", currentItem.name);
                setBreadCrumb(breadCrumb.slice(0, index + 1));
                setFolderName(currentItem.name);
            }
        });

        setCurrentFolder({
            id: folder_id,
            name: folderName
        });
    }

    if (tileStyle) {
        // Campaign-builder add-content sheet — the prototype's .crumb-row,
        // extended to the REAL trail depth (the prototype's own demo only
        // ever showed one level). Same goHome()/getFolderContent() as the
        // full Media Gallery's breadcrumb — just a different DOM shape.
        return (
            <button type="button" className="pp-cb-crumb-row" onClick={goHome}>
                <i className="bx bx-chevron-right chev" />
                <span className="seg" onClick={(e) => { e.stopPropagation(); goHome(); }}>
                    {t('addcontent.media_root_label')}
                </span>
                {breadCrumb.map((item, index) => (
                    <span key={item.id ?? index}>
                        {' / '}
                        <span
                            className={`seg ${breadCrumb.length - 1 === index ? 'current' : ''}`}
                            onClick={(e) => {
                                if (breadCrumb.length - 1 === index) return;
                                e.stopPropagation();
                                getFolderContent(item.id);
                            }}
                        >
                            {item.label}
                        </span>
                    </span>
                ))}
            </button>
        );
    }

    return (
        <div className='px-3 d-flex'>
            <span className='d-flex align-items-center  text-[#697a8d] ' >
                <i className="fas fa-home me-1 cursor-pointer" onClick={goHome}></i>
                {breadCrumb.length ? <i className="fas fa-angle-right me-2"></i> : ""}
            </span>

            {breadCrumb.map((item, index) => {
                return (
                    <span className='d-flex align-items-center text-light' key={index}>
                        {
                            breadCrumb.length - 1 != index ?
                                <>
                                    <span className='me-1 cursor-pointer' onClick={() => { getFolderContent(item.id) }}>{item.label}</span>
                                    <i className="fas fa-angle-right me-2"></i>
                                </>
                                :
                                <span className='me-1 fw-bold text-secondary'>{item.label}</span>
                        }
                    </span>
                )
            })}
        </div>
    )
}

BreadCrumb.defaultProps = {
    getData: () => { },
};

export default BreadCrumb